import React, { useState } from 'react';

import ChargerTaskDetailsDialog from '../../../screens/ChargerDetails/components/ChargerTaskDetailsDialog/component';

const DetailsTrigger = ({ children, task }) => {
  const [state, setState] = useState(false);

  const open = () => setState(true);
  const close = () => setState(false);

  return (
    <>
      {
        state && (
          <ChargerTaskDetailsDialog
            task={task}
            isOpen
            close={close}
          />
        )
      }
      <div className="link" onClick={open}>{children}</div>
    </>
  );
};

export default DetailsTrigger;
